import React from "react";
import { Container, Box, Typography, Link, Button } from "@mui/material";

const Home: React.FC = () => {
  return (
    <Container maxWidth="sm">
      <Box sx={{ py: 8, textAlign: "center" }}>
        <Typography variant="h2" component="h1" gutterBottom>
          Cayce Jondro
        </Typography>
        <Link href="/deep-map">Deep Map</Link>
      </Box>
    </Container>
  );
};

export default Home;
